import React from 'react';
import type {HTMLProps} from '@rmwc/types';
import clsx from 'clsx';
import styles from './Accordion.module.scss';
import '@rmwc/list/styles';

import {CollapsibleList, type CollapsibleListProps} from '@rmwc/list';
export const Accordion = ({
  className,
  ...props
}: CollapsibleListProps & Omit<HTMLProps, 'ref'>): React.JSX.Element => (
  <CollapsibleList
    className={clsx(className, styles.accordion)}
    {...props}
  />
);
